import { writable } from 'svelte/store'

export const backendVersion = writable('')
export const userContext = writable(null)
